import Config from 'config';
import { all, call, fork, put, select } from 'redux-saga/effects';

import request from '../../../lib/request';
import waitForSession from '../../../lib/wait-for-session';

import {
  getDateFilter,
  getReportSelected,
  getReportTimeRange,
  getCustomSelectedEvents,
  getCustomSelectedSlugsFromModal,
  getSelectedEventsSlugs
} from '../getters';
import { getUserId } from '../../session/getters';

import {
  ON_DASHBOARD_MOUNT_ERROR,
  ON_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED,
  ON_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR,
  ON_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS,
  ON_DASHBOARD_FETCH_BALANCES_SUCCESS,
  DASHBOARD_DOWNLOAD_REPORT_SUCCESS,
  DASHBOARD_DOWNLOAD_REPORT_ERROR,
  ON_SET_CUSTOM_EVENTS
} from '../actions';

export function* requestAndPut(requestParameters, actionCreator) {
  const result = yield call(...requestParameters);
  yield put(actionCreator(result));
}

const requestBalancesActionCreator = balances => ({
  type: ON_DASHBOARD_FETCH_BALANCES_SUCCESS,
  payload: balances ? balances.account_balances : []
});

const requestAccountReportActionCreator = report => ({
  type: ON_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS,
  payload: report ? report['event-report'] : false
});

function requestBalances() {
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/account_balances/totals`, options)
    .then(resp => resp.text())
    .then(responseAsText => {
      try {
        const bodyAsJson = JSON.parse(responseAsText);
        return bodyAsJson;
      }
      catch (e) {
        console.log('Error - invalid JSON from account_balances/totals');
        Raven.captureException(e);
      }
    });
}

const slugsForURLParam = (slugs) => slugs.map(slug => `&slugs[]=${slug}`).join('');

function requestAccountReport(userId, from, to, slugs) {
  const options = {
    credentials: 'include'
  };

  let url = `${Config.api.base}/users/${userId}/event_report?from=${from}&to=${to}`;

  if (slugs.length > 0) {
    url = `${url}${slugsForURLParam(slugs)}`;
  }

  return request(url, options)
    .then(resp => resp.json());
}

export function* onDashboardMount() {
  yield call(waitForSession);
  const userId = yield select(getUserId);
  const dateFilter = yield select(getDateFilter);
  const selectedSlugs = yield select(getSelectedEventsSlugs);

  try {
    if (!userId) {
      throw new Error('No user - aborting');
    }

    yield all([
      fork(requestAndPut, [requestBalances], requestBalancesActionCreator),
      fork(requestAndPut, [requestAccountReport, userId, dateFilter.from, dateFilter.to, selectedSlugs], requestAccountReportActionCreator)
    ]);
  }
  catch (e) {
    yield put({ type: ON_DASHBOARD_MOUNT_ERROR });
  }
}


export function* getAccountReportForTimeFrame() {
  yield call(waitForSession);
  const userId = yield select(getUserId);
  const dateFilter = yield select(getDateFilter);
  const selectedSlugs = yield select(getSelectedEventsSlugs);

  try {
    yield put({ type: ON_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED });
    yield fork(requestAndPut, [requestAccountReport, userId, dateFilter.from, dateFilter.to, selectedSlugs], requestAccountReportActionCreator);
  }
  catch (e) {
    yield put({ type: ON_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR });
  }
}

export function* fetchHostReport() {
  const userId = yield select(getUserId);
  const reportType = yield select(getReportSelected);
  const timeRange = yield select(getReportTimeRange);

  try {
    yield call(requestHostReport, userId, reportType, timeRange);
    yield put({ type: DASHBOARD_DOWNLOAD_REPORT_SUCCESS });
  }
  catch (e) {
    yield put({ type: DASHBOARD_DOWNLOAD_REPORT_ERROR });
  }
}

export function requestHostReport(userId, reportType, timeRange) {
  window.location.href = `${Config.api.host}/user_reports/${userId}/${reportType}.csv${timeRange}`;
}

export function* redirectToHomepage() {
  window.location.href = `${Config.api.host}`;
  return false;
}

export function* setCustomEvents() {
  const slugs = yield select(getCustomSelectedSlugsFromModal);
  const events = yield select(getCustomSelectedEvents);
  yield put({ type: ON_SET_CUSTOM_EVENTS, payload: { events, slugs }});
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/sagas.js